import styles from "./info-pages.module.css";

export const PrivacyPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h1>Privacy Policy</h1>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Last updated: 24th May 2025</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              At <b>TrailArt.store</b>, your privacy is important to us. This
              Privacy Policy explains how we collect, use, and protect your
              personal data in accordance with the UK General Data Protection
              Regulation (UK GDPR).
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>1) Who We Are</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We are the creators of <code>trailart.store</code>, a service that
              allows users to create and order custom prints of their runs,
              hikes, and other activities. We are based in the United Kingdom.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>2) What Data We Collect</h2>
          </div>
          <div className={styles.sectionContent}>
            <ul className={styles.unorderedList}>
              <li>
                <strong>Email address</strong> (used for account creation,
                communication, and login)
              </li>
              <li>
                <strong>Password</strong> (stored securely and encrypted)
              </li>
              <li>
                <strong>Transaction data</strong> (amount, date, and status) is
                stored in Stripe when you make a purchase.
              </li>
            </ul>
            <p>
              We do <strong>not</strong> collect shipping addresses or payment
              card details — all payments are handled securely by Stripe.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>3) Why We Collect This Data</h2>
          </div>
          <div className={styles.sectionContent}>
            <ul className={styles.unorderedList}>
              <li>Create and manage your account</li>
              <li>Allow you to sign in securely</li>
              <li>
                Communicate with you about your orders, account activity, and
                service updates
              </li>
              <li>Comply with our legal obligations</li>
            </ul>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>4) Lawful Basis for Processing</h2>
          </div>
          <div className={styles.sectionContent}>
            <ul className={styles.unorderedList}>
              <li>
                <strong>Consent</strong> – When you voluntarily sign up or agree
                to receive communication
              </li>
              <li>
                <strong>Contract</strong> – When processing is necessary for
                delivering services you’ve requested
              </li>
              <li>
                <strong>Legal obligation</strong> – To comply with financial and
                data protection laws
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>5) How We Store and Protect Your Data</h2>
          </div>
          <div className={styles.sectionContent}>
            <ul className={styles.unorderedList}>
              <li>Your data is stored securely in our database</li>
              <li>Passwords are hashed and cannot be read in plain text</li>
              <li>
                We use HTTPS and industry-standard security practices to protect
                your data
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>6) Sharing Your Data</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We do <strong>not</strong> sell or share your data with third
              parties except:
            </p>
            <ul className={styles.unorderedList}>
              <li>
                <strong>Stripe</strong>, for payment processing (you are
                redirected to Stripe – we do not store payment info)
              </li>
              <li>Legal authorities, if required by law</li>
            </ul>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>7) Your Rights</h2>
          </div>
          <div className={styles.sectionContent}>
            <ul className={styles.unorderedList}>
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data (“right to be forgotten”)</li>
              <li>Object to processing or withdraw consent</li>
              <li>
                File a complaint with the ICO (
                <a href="https://ico.org.uk/">https://ico.org.uk/</a>)
              </li>
            </ul>
            <p>
              To exercise any of these rights, email us at:{" "}
              <strong>support@trailart.store</strong>
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>8) Cookies</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We use cookies only for essential functionality (e.g. Stripe
              payments). For more details, see our{" "}
              <a href="./cookie-policy.md">Cookie Policy</a>.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>9) Changes to This Policy</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>
              We may update this policy occasionally to reflect legal or service
              changes. Updates will be posted here.
            </p>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>10) Contact Us</h2>
          </div>
          <div className={styles.sectionContent}>
            <p>If you have questions about this policy, contact:</p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@trailart.store">support@trailart.store</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
